module.exports = __webpack_public_path__ + "static/media/church.d8cb62bd.jpg";